import { Component, OnInit } from '@angular/core';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { UserService } from 'app/users/user.service';
import { Router } from '@angular/router';
import { ProductImage, TierName } from 'app/models/products.model';
import { formatCurrency, formatDate } from 'app/utilities/format-utils';
import { Subscription } from 'app/models/customer.model';
import { SharedDataService } from 'app/services/sharedData.service';
import { CustomerService } from 'app/services/customer.service';
import { environment } from 'environments/environment';
import { AuthService, Passport } from 'app/services/auth.service';
import * as uuid from 'uuid';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-renew-subscriptions',
  templateUrl: './renew-page.component.html',
  styleUrls: ['./renew-page.component.css']
})

export class RenewSubscriptionsComponent implements OnInit {
    membership: string = TierName.NONMBR;
    loaded: boolean = false;
    subscriptions: Subscription[] = [];
    isSmallView: boolean = false;


    constructor(private router: Router,
        private sharedDataService: SharedDataService,
        private userService: UserService,
        private customerService: CustomerService,
        private alertService: AlertsService,
        private authService: AuthService,
        private responsive: BreakpointObserver
    ) { }
    
    ngOnInit() {
      let token: Passport  = {
        id: uuid.v4(),
        userFlow: 'renew',
        customerNumber: this.userService.profile.customerNumber
      }
      this.determineViewMode();
      this.authService.getToken(token).subscribe();
        this.membership = this.userService.isInGroup('member') ? TierName.MEMBER : TierName.NONMBR;
        this.loadData();
    }

    loadData() {
        this.sharedDataService.getSubscriptions.subscribe(data => {
            if (data !== null) {
                const subscriptions = data.filter( (d) => d.Status.Name === "Active");
                for (const sub of subscriptions) {
                  const subscription: Subscription = {
                        productName: sub.Components[0].ProductName,
                        productType: "Online",
                        productNumber: sub.Components[0].ItemNumber,
                        status: sub.Status.Name,
                        term: this.getTerm(sub.ServicePeriod.Code),
                        userCount: sub.Components[0].QuantityOrdered,
                        startDate: new Date(sub.TermStarts).toLocaleDateString(),
                        expireDate: new Date(sub.AgreementExpires).toLocaleDateString(),
                        totalAmount: formatCurrency(sub.Components[0].AccessPoint.Amounts.TotalAmount),
                        agreementId: sub.AgreementId
                    }
                    this.subscriptions.push(subscription);
                } 
            }    
            this.loaded = true;               
        });                  
    }

    getProductImage(productCode: string) {
        return ProductImage.hasOwnProperty(productCode) ? ProductImage[productCode] : "";
    }    

    getTerm(termValue: string) {
        const term = termValue.substring(2).replace(/0/gi,'');    
        return "Term: " + term + ((term === '1') ? " Year": " Years");
    }

    renew(agreementId:string) {
      this.customerService.renewSubscription(agreementId).
      subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Failed to Renew Subscription:" + res.ErrorMessage);
          } else {  
            window.location.href = environment.amaPayment + '?applnm=ocm&ordNumber=' + encodeURIComponent(res.Data.EncryptedOrderNumber) + 
              '&paramRtnUrl=' + environment.ocm + '/confirmation?orderNumber=';
          }
        },
        error: error => {
          this.alertService.displayError("Failed to Renew Subscription:" + error.message);
        }  
      });         
    }

    determineViewMode() {
      this.responsive.observe([
        Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait])
          .subscribe(result => {
            const breakpoints = result.breakpoints;
            this.isSmallView = false;
            if (breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]) {
              this.isSmallView = true;
            } 
          });
    }

}    